import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, ListGroup } from 'react-bootstrap';
import apiClient from '../api/axios';
import { toast } from 'react-toastify';

const UploadFileModal = ({ show, onHide, arrangement, onFilesUpdate }) => {
    const [files, setFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    useEffect(() => {
        if (show) {
            setFiles([]);
            setIsUploading(false);
            const fileInput = document.getElementById('file-upload-input-modal');
            if(fileInput) fileInput.value = "";
        }
    }, [show]);

    const handleFileChange = (e) => {
        if (e.target.files) {
            setFiles(Array.from(e.target.files));
        }
    };

    const handleUpload = async () => {
        if (files.length === 0) {
            toast.warn('Сначала выберите файлы для загрузки.');
            return;
        }

        setIsUploading(true);
        let successCount = 0;
        let errorCount = 0;

        const MAX_FILE_SIZE = 15 * 1024 * 1024;
        const ALLOWED_FILE_TYPES = ['audio/mpeg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

        for (const file of files) {
            if (file.size > MAX_FILE_SIZE) {
                toast.error(`Файл "${file.name}" слишком большой. Максимальный размер - 15 МБ.`);
                errorCount++;
                continue;
            }
            const accepted_chordpro_mimetypes = ['text/plain', 'application/octet-stream', ''];
            const isChordPro = ['.chordpro', '.chopro', '.cho'].some(ext => file.name.toLowerCase().endsWith(ext)) && accepted_chordpro_mimetypes.includes(file.type);
            const isOnSong = file.name.toLowerCase().endsWith('.onsong');

            if (!ALLOWED_FILE_TYPES.includes(file.type) && !isChordPro && !isOnSong) {
                toast.error(`Недопустимый тип файла "${file.name}". Разрешены только PDF, MP3, DOC, DOCX, ChordPro (.chordpro, .chopro, .cho) и OnSong (.onsong).`);
                errorCount++;
                continue;
            }

            const formData = new FormData();
            formData.append('file', file);
            try {
                await apiClient.post(`/arrangements/${arrangement.id}/files`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                toast.success(`Файл "${file.name}" успешно загружен!`);
                successCount++;
            } catch (err) {
                const errorMessage = err.response?.data?.detail || 'Ошибка загрузки файла';
                toast.error(`Ошибка при загрузке файла "${file.name}": ${errorMessage}`);
                errorCount++;
            }
        }

        setIsUploading(false);
        if (successCount > 0) {
            onFilesUpdate();
        }
        
        setFiles([]);
        const fileInput = document.getElementById('file-upload-input-modal');
        if(fileInput) fileInput.value = "";

        if (errorCount === 0) {
            onHide();
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Загрузить файлы</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted small">Вы можете выбрать несколько файлов (PDF, MP3, DOC, DOCX, ChordPro (.chordpro, .chopro, .cho), OnSong (.onsong)), каждый размером не более 15 Мб.</p>
                <Form.Group controlId="file-upload-input-modal" className="mb-3">
                    <Form.Control 
                        type="file" 
                        onChange={handleFileChange} 
                        multiple // Allow multiple file selection
                        accept=".pdf,.mp3,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.chordpro,.chopro,.cho,text/plain,.onsong" 
                    />
                </Form.Group>

                {files.length > 0 && (
                    <ListGroup className="mb-3">
                        {files.map((file, index) => (
                            <ListGroup.Item key={index} as="li" className="d-flex justify-content-between align-items-start">
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold">{file.name}</div>
                                    <small className="text-muted">{(file.size / 1024 / 1024).toFixed(2)} МБ</small>
                                </div>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                )}

                <Button 
                    variant="primary" 
                    onClick={handleUpload} 
                    disabled={files.length === 0 || isUploading}
                    className="w-100"
                >
                    {isUploading ? `Загрузка... (${files.length} шт.)` : `Загрузить (${files.length} шт.)`}
                </Button>
            </Modal.Body>
        </Modal>
    );
};

export default UploadFileModal;